import { useState } from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';

import { useAuth } from '../../contexts/auth';
import Head from '../../components/Head';
import Layout from "../../layout";
import MyData from './MyData';
import Security from './Security';
import useStyles from './styles';

const mockFolders = () => ["Meus Dados", 'Segurança']

const Profile = () => {
  const { logout, isGPID } = useAuth();
  const classes = useStyles();

  const [folders] = useState(mockFolders());
  const [selectedFolder, setSelectedFolder] = useState(0);

  return (
    <Layout page="profile" innerPage backLink={!isGPID ? '/' : 'minha-saude/vacina'}>
      <Head>Perfil</Head>
      <Container component="section" className={classes.container}>
        <Grid container spacing={2}>
          <Hidden only="xs">
            <Grid item xs={3}>
              <Box component="nav" className={classes.menuContainer}>
                <List component="ul" aria-label="pastas do perfil">
                  {folders.map((folder, index) => {
                    const isSelected = () => selectedFolder === index;
                    return (
                      <ListItem
                        key={`folder-${folder}`}
                        button
                        component="li"
                        onClick={() => setSelectedFolder(index)}
                        selected={isSelected()}
                        disabled={isSelected()}
                        className={isSelected() ? 'selected' : ''}
                      >
                        {folder}
                      </ListItem>
                    )
                  })}
                </List>
                <Divider variant="middle" className={classes.divider} />
                <ListItem
                  id="logout-button"
                  component="li"
                  button
                  onClick={logout}
                >
                  Sair
                </ListItem>
              </Box>
            </Grid>
          </Hidden>

          <Hidden only="xs">
            {selectedFolder === 0 ? (
              <MyData />
            ) : (
              <Security />
            )}
          </Hidden>

          <Hidden smUp>
            <MyData />
            <Box width="100%" marginY={3}>
              <Divider variant="middle" />
            </Box>
            <Security />
          </Hidden>
        </Grid>
      </Container>
    </Layout>
  );
}

export default Profile;